import { CategoryChip } from './CategoryChip'
import { useCategorySelectQuery } from '@/hooks/useCategories'

type RubanCategoryType = {
  selectedCategoryId: string | null
  setSelectedCategoryId: (s: string | null) => void
}

const RubanCategory: React.FC<RubanCategoryType> = ({
  selectedCategoryId,
  setSelectedCategoryId,
}) => {
  const { data: categories, isLoading: catLoading } = useCategorySelectQuery()
  return (
    <div className='flex w-full overflow-x-auto scrollbar-hide gap-3'>
      <CategoryChip
        active={!selectedCategoryId}
        onClick={() => setSelectedCategoryId(null)}
        label='Toutes'
      />
      {catLoading ? (
        <div className='py-2 text-sm text-muted-foreground'>
          Chargement des catégories…
        </div>
      ) : (
        categories?.map((c) => (
          <CategoryChip
            key={c.id}
            active={selectedCategoryId === c.id}
            onClick={() => setSelectedCategoryId(c.id)}
            label={c.name}
          />
        ))
      )}
    </div>
  )
}

export default RubanCategory
